(() => {
  const applyEfesAuditFixes = () => {
    const allProductsButton = document.querySelector(
      '.efes-home-hero__actions .efes-btn[href*="/collections/tum-urunler"]'
    );

    if (allProductsButton && /yeni sezonu keşfet/i.test(allProductsButton.textContent || '')) {
      allProductsButton.textContent = 'Tüm ürünleri gör';
    }

    document.querySelectorAll('.efes-benefit p').forEach((paragraph) => {
      const currentText = paragraph.textContent || '';
      if (currentText.includes('stokta bulunan beden ve renk seçeneklerini')) {
        paragraph.textContent = currentText.replace(
          'stokta bulunan beden ve renk seçeneklerini',
          'beden ve renk seçeneklerini'
        );
      }
    });

    const productMain = document.querySelector('main[data-template*="product"]');
    if (!productMain || productMain.querySelector('.efes-product-service-links')) return;

    const links = document.createElement('nav');
    links.className = 'efes-product-service-links';
    links.setAttribute('aria-label', 'Sipariş bilgileri');
    links.innerHTML = [
      '<a href="/pages/kargo-ve-teslimat">Kargo ve teslimat</a>',
      '<a href="/pages/iade-ve-degisim">İade ve değişim</a>',
      '<a href="/pages/sikca-sorulan-sorular">Sıkça sorulan sorular</a>'
    ].join('');

    const purchaseArea = productMain.querySelector(
      '.product-details .product-form-buttons, .product-details buy-buttons, .product-details [class*="buy-buttons"]'
    );
    const description = productMain.querySelector('.product-details .rte');
    const anchor = purchaseArea?.closest('.shopify-block') || purchaseArea;

    if (anchor) {
      anchor.insertAdjacentElement('afterend', links);
    } else if (description) {
      description.insertAdjacentElement('beforebegin', links);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyEfesAuditFixes, { once: true });
  } else {
    applyEfesAuditFixes();
  }

  document.addEventListener('shopify:section:load', applyEfesAuditFixes);
})();
